import React, { useCallback } from "react";
import { type WrappedFieldProps } from "redux-form";
import { Flex } from "@appsmith/ads";
import { BlankState } from "./components/BlankState";
import { Header } from "./components/Header";
import { useTools } from "./hooks/useTools";
import { useToolSelection } from "./hooks/useToolSelection";
import { ToolGroup } from "./components/ToolGroup";
import { useToolEdit } from "./hooks/useToolEdit";
import { useDispatch } from "react-redux";
import { openCarbonModal } from "ee/actions/aiAgentActions";
interface AIChatIntegrationsProps extends WrappedFieldProps {
  formName: string;
}

const AIChatIntegrations = (props: AIChatIntegrationsProps) => {
  const { input } = props;
  const toolGroups = useTools(input.value);
  const { onSelectAll, onToolSelect } = useToolSelection(
    input.value,
    input.onChange,
  );
  const { onToolEdit } = useToolEdit(input.value, input.onChange);
  const dispatch = useDispatch();
  const handleAddActionsButtonClick = useCallback(() => {
    dispatch(openCarbonModal({ shouldOpen: true }));
  }, [dispatch]);

  return (
    <Flex flexDirection="column" gap="spaces-4">
      <Header
        onAddActionsButtonClick={handleAddActionsButtonClick}
        showAddActionsButton={toolGroups.length > 0}
      />
      {toolGroups.length === 0 && (
        <BlankState onConnectClick={handleAddActionsButtonClick} />
      )}
      {toolGroups.map((group) => (
        <ToolGroup
          group={group}
          key={group.id}
          onSelectAll={onSelectAll}
          onToolEdit={onToolEdit}
          onToolSelect={onToolSelect}
        />
      ))}
    </Flex>
  );
};

export default AIChatIntegrations;
